module.exports = __webpack_public_path__ + "static/media/calendarGraphic.2b7ce89b.png";